import { resolve } from 'rsvp';
import { A } from '@ember/array';
import BaseAnalytics from '../base-analytics';
import { handleErrorResponseWithModal } from 'sh-www/utils/handles-errors';

/**
 * @type {{ wide: boolean|undefined, param: string, csvLabel: string, label: string }[]}
 */
const TABLE_COLUMNS = [{
  label: 'Company',
  csvLabel: 'Company',
  param: 'companyName',
  wide: true,
  sortDescending: false,
}, {
  label: 'Earnings ($USD)',
  csvLabel: 'Earnings ($USD)',
  param: 'amount',
  sortDescending: true,
  rightAlign: true,
  display: (amount) => amount.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD'
  }),
}];

/** @type module */
const FreelancerTotalsAnalytics = BaseAnalytics.extend({

  /** @inheritDoc */
  hideGraph: true,

  /** @inheritDoc */
  annual: false,

  /** @inheritDoc */
  title: 'Earnings - Total',

  /** @inheritDoc */
  init() {
    this._super(...arguments);
    this.setProperties({ tableColumns: TABLE_COLUMNS, factoidLayout: A([]) });
  },

  /** @inheritDoc */
  queryData() {
    return this.get('userCommandService').getAnalyticsLTV().catch((e) => {
      handleErrorResponseWithModal(
        this,
        e,
        'There was an error loading these totals. Please refresh and try again.',
        'FreelancerTotalsAnalytics::queryData -- error loading ltv',
      );
      return A([]);
    });
  },

  /** @inheritDoc */
  _queryFactoids() {
    return resolve(A([]));
  },
});

export default FreelancerTotalsAnalytics;
